import {useCallback, useEffect, useState} from 'react'
import * as api from '@/api/home'
import style from '../style.module.less'
import siteLogo from '../images/site.png'
import emailLogo from '../images/email.png'
import phoneLogo from '../images/phone.png'


const Footer = () => {
    const [data, setData] = useState<any>({})

    const getData = useCallback(async () => {
        const res = await api.getBottomInfo()
        if (res.status) {
            setData(res.data[0] || {})
        }
    }, [])

    useEffect(() => {
        getData()
    }, [getData])

    return (
        <div className={style.footer}>
            <div className='layout-container flex'>
                <div>
                    <div className='font-18'>联系方式</div>
                    <div className='flex align-center mt-16'>
                        <img className='mr-5' src={siteLogo} alt=""/>
                        <span><a style={{color: 'inherit'}} href="https://www.dongcheng.com" target="_blank"
                                 rel="noopener noreferrer">https://www.dongcheng.com</a></span>
                    </div>
                    <div className='flex align-center mt-8'>
                        <img className='mr-5' src={emailLogo} alt=""/>
                        <span><a style={{color: 'inherit'}} href={`mailto:${data.yx}`}>{data.yx}</a></span>
                    </div>
                    <div className='flex align-center mt-8'>
                        <img className='mr-5' src={siteLogo} alt=""/>
                        <span>{data.lxdh}</span>
                    </div>
                </div>
                <div className='flex-1'></div>
                <div>
                    <div className='font-18'>公司地址</div>
                    <div className='mt-16'>江苏省启东市天汾电动工具产业园</div>
                    <div className='mt-8'>Power Tools Industrial Park of Tianfen,</div>
                    <div className='mt-8'>Qidong City,Jiangsu Province</div>
                </div>
                <div className='flex-1'></div>
                <div>
                    <div className='font-18'>售后热线</div>
                    <div className='mt-20 primary-color'>400-182-5988/ 0513-83290666</div>
                    <div className={`${style['footer-btn']} flex align-center mt-16`}>
                        <img src={phoneLogo} alt="" className='mr-4'/>
                        <span>立即咨询</span>
                    </div>
                </div>
            </div>
            <div style={{display: 'ruby', padding: '0 30px'}}>
                <a style={{color: 'white'}} href="https://beian.miit.gov.cn/#/Integrated/index"
                   rel="noreferrer" target="_blank">
                    苏ICP备:10227676号
                </a>
                <img style={{marginLeft: 20, width: "15px"}} src="https://obs.dcatools.cn/DMSCS/11.png"/>
                <a style={{color: 'white'}} href="https://beian.mps.gov.cn/#/query/webSearch?code=32068102810301"
                   rel="noreferrer" target="_blank">
                    苏公网安备:32068102810301
                </a>
            </div>
        </div>
    )
}

export default Footer
